import { getDefaultHeaders, http } from '../../utils/apiRequests';

const upsertSchedule = async (
  schedule: UpsertScheduleType,
  method: 'put' | 'post',
  httpFunc: (request: RequestInfo, config: any) => any = http
) => {
  const url = `/api/v2/schedules${schedule.id ? `/${schedule.id}` : ''}`;
  if (schedule.id) {
    delete schedule.id;
  }
  const config = {
    method,
    body: JSON.stringify(schedule),
    headers: getDefaultHeaders(),
  };

  const response = await httpFunc(url, config);
  const json = await response.json();

  return json.data;
};

export interface Schedule {
  accountID: string;
  createdAt: string;
  forceLastDay: boolean;
  frequency: string;
  id: string;
  modifiedAt: string;
  runAt: string;
  runState: string;
  startAt: string;
  stateValues: any;
  workflowID: string;
  workspaceID: string;
}

export interface UpsertScheduleType {
  forceLastDay: boolean;
  frequency: string;
  startAt: string;
  workflowID: string;
  id?: string;
}

export interface deleteScheduleType {
  meta: { requestID: string; version: string };
}

export const getSchedules = async (
  workflowUUID: string,
  httpFunc: (request: RequestInfo, config: any) => any = http
) => {
  const url = `/api/v2/schedules?workflowIDs=${workflowUUID}&sortBy=createdAt:asc&isActive=true`;

  const config = {
    method: 'get',
    headers: getDefaultHeaders(),
  };

  const response = await httpFunc(url, config);
  const json = await response.json();

  return json.data;
};

export const upsertScheduleService = async (
  schedule: UpsertScheduleType,
  httpFunc: (request: RequestInfo, config: any) => any = http
) => {
  return upsertSchedule(schedule, schedule.id ? 'put' : 'post', httpFunc);
};

export const deleteSchedule = async (
  scheduleID: string,
  httpFunc: (request: RequestInfo, config: any) => any = http
) => {
  const url = `/api/v2/schedules/${scheduleID}`;

  const config = {
    method: 'delete',
    headers: getDefaultHeaders(),
  };

  const response = await httpFunc(url, config);
  const json = await response.json();

  return json;
};
